import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBContainer
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";
import { useUser } from "../../../contexts/UserContext";
import { useSetUserRegistration, useUserRegistration } from "../../../contexts/UserRegistrationContext";
import { _axios } from "../../../utils/axios";
import { formatDate } from "../../../utils/date";
import style from "./accountVerificationStatus.module.css";


const AccountVerificationStatus: React.FC = () => {
  const user = useUser();
  const setUserRegistration = useSetUserRegistration()
  const navigate = useNavigate();
  const userRegistration = useUserRegistration()
  const [commentList, setCommentList] = useState<any>([])



  const getApplicationStatus = () => {
    _axios.post(`${BASE_URL}/api/user-verification-comments/user`,
      {
        user_id: user?.user_id
      }
    )
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        console.log('response?.data', response?.data)
        setCommentList(response?.data?.data)
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
  }

  useEffect(() => {
    getApplicationStatus()
  }, []);

  const onApprove = () => {
    _axios.patch(`${BASE_URL}/api/user-details`,
    {
      user_id: user?.user_id,
      regestration_status: 1,
    })
    .then(function (response) {
      console.log('response', response)
      setUserRegistration({...userRegistration, regestration_status: 1})
      navigate('/user-dashboard')
      // alert("Submitted successfully")


    }).catch(function (error) {
      // handle error
      console.log(error);
    })
  }


  return (
    <div className="mb-32">
     <div className={style.pageTitle}>Account Verification Status</div>
    <MDBContainer className="py-5">
      <div className="main-timeline-4 text-white">
        {commentList?.map((item: any, index: number) => {
          return (
            <div >
              {item.comments_by === 'user' ? (
                <div className="timeline-4 right-4-custom">
                  <MDBCard className="gradient-custom">
                    <MDBCardBody className="p-4">
                      <div className="flex justify-between mb-3">
                        <p className="small text-grey-600 mb-4 text-xl font-semibold">{formatDate(new Date(item.updated_date))}</p>
                        <MDBBtn className="text-white mb-0" color="primary" disabled>
                          Review
                        </MDBBtn>
                      </div>
                      <p className="text-grey-600">{item.comment}
                      </p>
                    </MDBCardBody>
                  </MDBCard>
                </div>
              ) : item.status == 0 ?
                (
                  <div className="timeline-4 leftContainer-4">
                    <MDBCard className="gradient-custom-4">
                      <MDBCardBody className="p-4">
                        <div className="flex justify-between mb-3">
                          <p className="small text-grey-600 mb-4 text-xl font-semibold">{formatDate(new Date(item.updated_date))}</p>
                          <MDBBtn className="text-white mb-0" color="danger" disabled>
                            Return
                          </MDBBtn>
                        </div>
                        <p className="text-grey-600">{item.comment}</p>
                        <p className="text-grey-600">
                          {'To update your registration details '}
                          {index === ((commentList?.length ?? 0) -1) && <span onClick={()=> navigate('/onboarding/user-regestration-form')} className="font-bold cursor-pointer" >{' Click Here'}</span>}
                        </p>

                      </MDBCardBody>
                    </MDBCard>
                  </div>
                ) : item.status == 1 && (item.comments_by === 'Level 2' || item.comments_by === 'Level 3') ?
                (
                  <div className="timeline-4 leftContainer-4 leftApprove-4">
                  <MDBCard className="gradient-custom-5">
                    <MDBCardBody className="p-4">
                      <div className="flex justify-between mb-3">
                        <p className="small text-grey-600 mb-4 text-xl font-semibold">{formatDate(new Date(item.updated_date))}</p>
                        <MDBBtn color='success' disabled className="text-white bg-green-800 border-emerald-500 mb-0" >
                          Approved
                        </MDBBtn>
                      </div>
                      <p className="text-white">
                        {item.comment}
                        <span className="font-bold cursor-pointer" onClick={onApprove}>{' Click Here'}</span>
                      </p>

                    </MDBCardBody>
                  </MDBCard>
                </div>
                )
                : null}
            </div>
          )
        })}


      </div>
    </MDBContainer>
</div>
  );
};

export default AccountVerificationStatus;
